import camelcaseKeys from 'camelcase-keys';
import DealStageAPI from 'dashboard/api/dealStages';
import { createStore } from 'dashboard/store/storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const camelizeStage = data => camelcaseKeys(data || [], { deep: true });

export const useDealStagesStore = createStore({
  name: 'dealStages',
  type: 'pinia',
  API: DealStageAPI,

  getters: {
    orderedStages: state =>
      [...state.records].sort((a, b) => a.position - b.position),
  },

  actions: () => ({
    async fetch() {
      this.setUIFlag({ fetchingList: true });
      try {
        const {
          data: { payload },
        } = await DealStageAPI.get();
        this.records = camelizeStage(payload);
        return this.records;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        this.setUIFlag({ fetchingList: false });
      }
    },

    async reorder(orderedIds) {
      try {
        const {
          data: { payload },
        } = await DealStageAPI.reorder(orderedIds);
        this.records = camelizeStage(payload);
        return this.records;
      } catch (error) {
        return throwErrorMessage(error);
      }
    },
  }),
});
